// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WESWv","type":"styles_type__3ne4Z","choices":"styles_choices__eUf-b"};